'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendVisitorEmailAddress = sendVisitorEmailAddress;
exports.sendOfflineMessage = sendOfflineMessage;

var _noAuthApiClient = require('conversations-core/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGES_API_PREFIX = 'messages/v2';

function sendVisitorEmailAddress(_ref) {
  var email = _ref.email,
      sessionId = _ref.sessionId;

  return _noAuthApiClient2.default.post(MESSAGES_API_PREFIX + '/visitor/public', {
    query: { sessionId: sessionId, email: email }
  });
}

function sendOfflineMessage(_ref2) {
  var message = _ref2.message,
      email = _ref2.email,
      portalId = _ref2.portalId,
      sessionId = _ref2.sessionId;

  var welcomeMessageId = (0, _ConversationalMessageModel.getWelcomeMessageId)(message);

  return _noAuthApiClient2.default.post(MESSAGES_API_PREFIX + '/email/public/' + welcomeMessageId, {
    query: { portalId: portalId, sessionId: sessionId },
    data: {
      email: email,
      text: (0, _ConversationalMessageModel.getText)(message),
      fromUrl: (0, _ConversationalMessageModel.getUrl)(message),
      timestamp: (0, _PubNubMessageModel.getTimestamp)(message)
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/VisitorApiClient.js
// module id = 83
// module chunks = 0 1